import React, { FC } from 'react';
import { SystemButtonHyperlinkProps } from '../button.types';
import { Hyperlink } from '../../Hyperlink';
import { SystemHyperlinkDefault } from '../systemButtonDefaultProps';
import styles from './secondary_button.module.scss';
import { SystemButtonContent } from '../SystemButton';

type Props = {
  iconLeft?: string;
  iconRight?: string;
} & SystemButtonHyperlinkProps;

export const SecondaryHyperlink: FC<Props> = ({
  children,
  target,
  href,
  rel,
  source,
  iconLeft,
  iconRight,
  onClick,
}) => {
  return (
    <Hyperlink
      className={styles.secondary}
      target={target}
      href={href}
      rel={rel}
      source={source}
      onClick={onClick}
    >
      <SystemButtonContent iconLeft={iconLeft} iconRight={iconRight}>
        {children}
      </SystemButtonContent>
    </Hyperlink>
  );
};

SecondaryHyperlink.defaultProps = SystemHyperlinkDefault;
